import styled from 'styled-components'
import { GuestbookEvent } from '@/shared/types'
import { Routes } from 'routes'
import { Link } from 'react-router-dom'
import { DateTime } from 'luxon'
import { CategoryLabelMap, Image } from '@/ui/components'
import { FormattedMessage } from 'react-intl'
import { strings } from './EventTile.strings'

const Row = styled(Link)`
  position: relative;
  cursor: pointer;
  text-decoration: none;

  display: flex;
  flex-direction: column;
  justify-content: space-around;
  max-height: 372px;
  width: 280px;
  gap: 0;

  background-color: ${({ theme }) => theme.colors.button.secondary};

  &:hover,
  &:focus {
    > div {
      background-color: ${({ theme }) => theme.colors.brand.secondary.hover};
    }
    > img {
      opacity: 0.8;
    }
  }

  &:active {
    > div {
      background-color: ${({ theme }) => theme.colors.brand.secondary.active};
    }
  }
`

const StyledImage = styled(Image)`
  width: 100%;
  max-height: 230px;
  object-fit: cover;
  img {
    border-radius: 0;
  }
`

const Placeholder = styled.div`
  height: 100%;
  width: 100%;
  background-color: grey;
  min-height: 224px;
`

const Container = styled.div`
  display: grid;
  grid-template-rows: 1fr auto 1fr;
  text-align: start;
  padding: 8px;

  /* border-radius: 0 0 8px 8px; */
  background-color: ${({ theme }) => theme.colors.button.secondary};

  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: var(--default-text);
`

const MessageBanner = styled.div<{ $top?: number }>`
  position: absolute;
  top: ${({ $top }) => $top || 8}px;
  left: 8px;
  right: 8px;
  background-color: ${({ theme }) => theme.colors.system.critical.surface};
  color: ${({ theme }) => theme.colors.font.regular};
  padding: 8px 12px;
  /* font-size: 12px; */
  width: auto;
  text-align: center;
  /* border-radius: 4px; */
  z-index: 1;

  :hover {
    background-color: ${({ theme }) => theme.colors.decorative.lightPink};
  }
`

const CategorySpan = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.font.subdued};
`

const DateSpan = styled.span`
  /* font-size: 14px; */
  /* color: ${({ theme }) => theme.colors.font.subdued}; */
`

interface Props {
  event: GuestbookEvent
  //   link: string
}

export const EventTile: React.FC<Props> = ({ event }) => {
  const {
    category,
    date,
    images,
    title,
    welcomeHeader,
    welcomeMessage,
    closingHeader,
    closingMessage,
  } = event
  const showWelcomeMessage = !welcomeHeader || !welcomeMessage
  const showClosingMessage = !closingHeader || !closingMessage

  return (
    <Row to={`${Routes.eventDetail}${event.id}`}>
      {showWelcomeMessage && (
        <MessageBanner>
          <FormattedMessage {...strings.welcomePageMissing} />
        </MessageBanner>
      )}
      {showClosingMessage && (
        <MessageBanner $top={showWelcomeMessage ? 60 : undefined}>
          <FormattedMessage {...strings.closingPageMissing} />
        </MessageBanner>
      )}
      {images.length > 0 ? (
        <StyledImage imgSrc={images[0]} retryOptions={{ maxAttempts: 3 }} />
      ) : (
        <Placeholder />
      )}
      <Container>
        <h3>{title}</h3>
        <CategorySpan>{CategoryLabelMap[category]}</CategorySpan>
        <DateSpan>
          {DateTime.fromISO(date).toLocaleString({
            month: 'long',
            day: 'numeric',
            year: 'numeric',
          })}
        </DateSpan>
      </Container>
    </Row>
  )
}
